import MojitoCore from 'mojito/core';

import {resolveBackground} from '#core/utils/color-utils.js';
import {isMobile} from '#core/utils/context-utils.js';

import {generateSkeletonPart} from '#core/application/modules/tiles/skeleton-part/index.js';
import {
    generatePrimaryButton,
    generateTertiaryButton,
    generateToggleButton,
} from '#core/application/modules/tiles/button/index.js';
import {CLOSE_BUTTON_TYPES, generateCloseButton} from '#core/application/modules/tiles/close-button/index.js';
import {BasePalette} from '#core/application/modules/base-palette.js';

const merge = MojitoCore.Presentation.uiStyle.merge;

export function quickStartGuideDialogConfig(PALETTE) {
    const QSG_DIALOG_SKELETON_PART = generateSkeletonPart(PALETTE.QSG_DIALOG_SKELETON_PART);

    return {
        QuickStartGuideDialogSkeleton: {
            fullWidth: QSG_DIALOG_SKELETON_PART,
            halfOfWidth: QSG_DIALOG_SKELETON_PART,
            thirdOfWidth: QSG_DIALOG_SKELETON_PART,
            button: QSG_DIALOG_SKELETON_PART,
        },
        QuickStartGuideDialog: {
            headerText: {
                style: {
                    ...PALETTE.QSG_DIALOG_TITLE_TEXT,
                },
            },
            headerSkeleton: QSG_DIALOG_SKELETON_PART,
            dialog: {
                centered: {
                    ...(isMobile() ? {margin: 'auto'} : {}),
                },
                dialogContent: {
                    style: {
                        ...resolveBackground(PALETTE.QSG_DIALOG_CONTAINER_BG),
                        padding: '0 16px 16px',
                        borderRadius: '8px',
                    },
                },
                closeButton: generateCloseButton(PALETTE.QSG_DIALOG_CLOSE_BUTTON, CLOSE_BUTTON_TYPES.CIRCULAR),
            },
            button: merge(generateToggleButton(PALETTE.QSG_DIALOG_GUIDE_BUTTON).unselected, {
                style: {
                    base: {
                        whiteSpace: 'normal',
                        textAlign: 'center',
                    },
                },
            }),
            buttonsMenuContainer: {
                defaultColumnSize: '48.5%',
            },
            description: {
                isHtml: true,
                style: {
                    ...PALETTE.QSG_DIALOG_TEXT,
                },
            },
            additionalInfo: {
                style: {
                    ...PALETTE.QSG_DIALOG_TEXT,
                },
            },
            nextButton: generatePrimaryButton(PALETTE.QSG_DIALOG_NEXT_BUTTON),
            backToMenuButton: generateTertiaryButton(PALETTE.QSG_DIALOG_BACK_TO_MENU_BUTTON),
        },
        // fully custom component to use inside GuidesContentGenerator
        QuickStartGuideSlide: {
            container: {
                padding: '8px 0px',
            },
            title: {
                textAlign: 'center',
                paddingBottom: '24px',
                ...PALETTE.QSG_DIALOG_TITLE_TEXT,
            },
            text: {
                fontFamily: BasePalette.palette.FONT_FAMILY,
                ...PALETTE.QSG_DIALOG_TEXT,
            },
            image: {
                width: '100%',
                height: 'auto',
                padding: '8px',
                boxSizing: 'border-box',
            },
        },
    };
}
